import React from 'react';
import { View } from 'react-native';
import { useStyleSheet } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
export const Placeholder = ({ style, fluid }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, fluid ? styles.fluid : null, style] },
        React.createElement(View, { style: styles.avatar }),
        React.createElement(View, { style: styles.main },
            React.createElement(View, { style: styles.row },
                React.createElement(View, { style: styles.name }),
                React.createElement(View, { style: styles.badge })),
            React.createElement(View, { style: [styles.row, styles.rowBottom] },
                React.createElement(View, { style: styles.message }),
                React.createElement(View, { style: styles.date }))),
        React.createElement(View, { style: styles.action })));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        padding: size.G,
        flexDirection: 'row',
        alignItems: 'center'
    },
    fluid: { flex: 1 },
    main: {
        flex: 1
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    rowBottom: {
        marginTop: size.D
    },
    avatar: {
        width: 55,
        height: 55,
        borderRadius: 9999,
        backgroundColor: color.invert2.p4,
        marginRight: size.G
    },
    name: {
        height: size.G,
        width: '30%',
        borderRadius: 9999,
        backgroundColor: color.invert2.p4,
        marginRight: size.G
    },
    message: {
        height: size.G,
        width: '50%',
        borderRadius: 20,
        backgroundColor: color.invert2.p4,
        marginRight: size.G
    },
    badge: {
        height: size.E,
        width: size.L,
        borderRadius: 9999,
        backgroundColor: color.invert2.p4
    },
    date: {
        height: size.G,
        width: size.N,
        borderRadius: 9999,
        backgroundColor: color.invert2.p4
    },
    action: {
        marginLeft: size.G,
        width: size.G,
        height: size.G,
        borderRadius: 9999,
        backgroundColor: color.invert2.p4
    }
}));
//# sourceMappingURL=Placeholder.js.map